import { TIMEZONE_DATA } from "@hex/common";

import { lookupTimezoneOffset } from "./timezoneOffsetUtils";
import type { Timezone, TimezoneWithoutOffset } from "./timezoneTypes";

const utcWithoutOffset: TimezoneWithoutOffset = {
  label: "UTC",
  ianaCode: "Etc/UTC",
};

export const UTC_TIME: Timezone = lookupTimezoneOffset(utcWithoutOffset);

const timezonesWithoutOffset: TimezoneWithoutOffset[] = TIMEZONE_DATA;

// Minimal timezone list - selected subset of most commonly used timezones
const MINIMAL_TIMEZONE_CODES = new Set([
  "Etc/UTC",
  "Pacific/Pago_Pago",
  "Pacific/Honolulu",
  "Pacific/Marquesas",
  "America/Anchorage",
  "America/Los_Angeles",
  "America/Denver",
  "America/Mexico_City",
  "America/New_York",
  "America/Puerto_Rico",
  "America/St_Johns",
  "America/Argentina/Buenos_Aires",
  "America/Sao_Paulo",
  "Atlantic/Cape_Verde",
  "Europe/Paris",
  "Africa/Cairo",
  "Europe/Moscow",
  "Asia/Tehran",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Kathmandu",
  "Asia/Dhaka",
  "Asia/Yangon",
  "Asia/Jakarta",
  "Asia/Manila",
  "Asia/Tokyo",
  "Australia/Brisbane",
  "Australia/Adelaide",
  "Australia/Sydney",
  "Pacific/Nauru",
  "Pacific/Auckland",
  "Pacific/Kiritimati",
]);

/* eslint-disable tree-shaking/no-side-effects-in-initialization -- no side effects */
const MinimalTimezonesWithoutOffset: TimezoneWithoutOffset[] =
  TIMEZONE_DATA.filter((tz) => MINIMAL_TIMEZONE_CODES.has(tz.ianaCode));

/** List of standard timezones */
export const TIMEZONE_ITEMS = timezonesWithoutOffset.map((tz) =>
  lookupTimezoneOffset(tz),
);

/** Minimal list of timezones */
export const MINIMAL_TIMEZONE_ITEMS = MinimalTimezonesWithoutOffset.map((tz) =>
  lookupTimezoneOffset(tz),
);
/* eslint-enable tree-shaking/no-side-effects-in-initialization -- re-enable */
